/**
 * Subtitles visibility mode enum.
 */
export var SubtitleMode;
(function (SubtitleMode) {
    SubtitleMode["SHOWING"] = "showing";
    SubtitleMode["HIDDEN"] = "hidden";
})(SubtitleMode || (SubtitleMode = {}));
//# sourceMappingURL=subtitle_mode.js.map